module.exports = __webpack_public_path__ + "static/media/SustainabilitySocialImpact.cc55f04e.pdf";